import * as yup from 'yup';

const validationSchema = formatMessage =>
  yup
    .object()
    .shape({
      title: yup.mixed().nullable(),
      languageCode: yup.mixed().nullable(),
      category: yup.mixed().nullable(),
      appVersion: yup.mixed().nullable(),
      status: yup.mixed().nullable(),
      companyType: yup.mixed().nullable(),
    })
    .test(
      'at-least-one-required',
      formatMessage({
        id: 'AT_LEAST_ONE_FIELD_IS_REQUIRED',
        defaultMessage: 'At least one field is required',
      }),
      // eslint-disable-next-line arrow-body-style
      value => {
        return value &&
          typeof value === 'object' &&
          Object.values(value).length > 0 &&
          !Array.isArray(value)
          ? Object.values(value).some(val => val && val !== '')
          : false;
      },
    );

export default validationSchema;
